import type { ListAuditsQuery } from '@hlt/contracts';

type AuditView = 'drafts' | 'completed' | 'all';

/** Audit list state kept in the URL so the view, search and page survive reloads and sharing. */
export interface AuditListSearch {
    view?: AuditView;
    q?: string;
    cursor?: string;
    page?: number;
}

const num = (v: unknown) => {
    const n = typeof v === 'number' ? v : typeof v === 'string' && v.trim() !== '' ? Number(v) : Number.NaN;
    return Number.isFinite(n) ? n : undefined;
};

export function parseAuditSearch(search: Record<string, unknown>): AuditListSearch {
    const out: AuditListSearch = {};
    if (search.view === 'drafts' || search.view === 'completed' || search.view === 'all') out.view = search.view;
    if (typeof search.q === 'string' && search.q.trim()) out.q = search.q.slice(0, 200);
    if (typeof search.cursor === 'string' && search.cursor.length <= 1024) out.cursor = search.cursor;
    const page = num(search.page);
    if (page !== undefined && Number.isInteger(page) && page > 1) out.page = page;
    return out;
}

/** Map URL state to the list query: newest audit date first, filtered by state and searched by area. */
export function toListQuery(search: AuditListSearch): ListAuditsQuery {
    const view = search.view ?? 'all';
    const status = view === 'drafts' ? 'draft' : view === 'completed' ? 'submitted' : undefined;
    return {
        limit: 25,
        sort: 'effectiveAt',
        ...(status ? { status } : {}),
        ...(search.q ? { search: search.q } : {}),
        ...(search.cursor ? { cursor: search.cursor } : {}),
    };
}
